import React from 'react';
import styled from 'styled-components';
import { FaRobot, FaBrain, FaGamepad, FaDice } from 'react-icons/fa';

const FeaturesSection = styled.section`
  background: linear-gradient(135deg, #0a0a12 0%, #121220 100%);
`;

const Container = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 1rem;
`;

const SectionHeader = styled.div`
  text-align: center;
  margin-bottom: 4rem;
`;

const Title = styled.h2`
  font-size: 2.5rem;
  margin-bottom: 1.5rem;
  color: var(--secondary);
  position: relative;
  padding-bottom: 1rem;
  display: inline-block;

  &::after {
    content: '';
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 4px;
    background: linear-gradient(90deg, var(--primary), var(--secondary));
    border-radius: 2px;
  }
`;

const Subtitle = styled.p`
  max-width: 800px;
  margin: 0 auto;
  color: var(--text-secondary);
  font-size: 1.1rem;
  line-height: 1.6;
`;

const FeaturesGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 2rem;
`;

const FeatureCard = styled.div`
  background-color: rgba(255, 255, 255, 0.05);
  border-radius: 8px;
  padding: 2rem;
  transition: all 0.3s ease;
  border: 1px solid rgba(255, 255, 255, 0.1);
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;

  &:hover {
    transform: translateY(-10px);
    box-shadow: 0 10px 30px rgba(0, 0, 0, 0.3);
    border-color: rgba(24, 202, 230, 0.3);
  }
`;

const IconWrapper = styled.div`
  width: 70px;
  height: 70px;
  border-radius: 50%;
  background: linear-gradient(135deg, var(--primary), var(--secondary));
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 1.5rem;
  font-size: 2rem;
  color: white;
`;

const FeatureTitle = styled.h3`
  font-size: 1.5rem;
  margin-bottom: 1rem;
  color: var(--secondary);
`;

const FeatureDescription = styled.p`
  color: var(--text-secondary);
  line-height: 1.6;
`;

const Features = () => {
  const features = [
    {
      icon: <FaBrain />,
      title: "AI-Driven Characters",
      description: "Characters make autonomous decisions based on your revelations, creating truly emergent gameplay and unique narratives each time."
    },
    {
      icon: <FaRobot />,
      title: "Multidimensional God Role",
      description: "Instead of direct control, guide AI characters through revelations, influencing but not determining their actions in the apocalyptic world."
    },
    {
      icon: <FaGamepad />,
      title: "Strategic Guidance",
      description: "Master the art of providing effective revelations, balancing directness and ambiguity to guide characters toward survival."
    },
    {
      icon: <FaDice />,
      title: "Emergent Storytelling",
      description: "Watch as unique stories unfold based on character decisions, environmental challenges, and your divine interventions."
    }
  ];

  return (
    <FeaturesSection id="features">
      <Container>
        <SectionHeader>
          <Title>Game Features</Title>
          <Subtitle>
            RIFT: Last One combines cutting-edge AI with innovative gameplay mechanics to create a truly unique gaming experience.
          </Subtitle>
        </SectionHeader>

        <FeaturesGrid>
          {features.map((feature, index) => (
            <FeatureCard key={index}>
              <IconWrapper>{feature.icon}</IconWrapper>
              <FeatureTitle>{feature.title}</FeatureTitle>
              <FeatureDescription>{feature.description}</FeatureDescription>
            </FeatureCard>
          ))}
        </FeaturesGrid>
      </Container>
    </FeaturesSection>
  );
};

export default Features;
